import { render } from "./TokenExpired.vue?vue&type=template&id=01229eb7&scoped=true"
import script from "./TokenExpired.vue?vue&type=script&lang=js"
export * from "./TokenExpired.vue?vue&type=script&lang=js"

import "./TokenExpired.vue?vue&type=style&index=0&id=01229eb7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01229eb7"]])

export default __exports__